import "@theme/front/init.scss"

import "select2"
import "select2/src/scss/core.scss"

import "bootstrap"

import "@mdi/font/css/materialdesignicons.min.css"

import LazyLoad from "vanilla-lazyload"
import "lightbox2/dist/css/lightbox.css";
import lightbox from "lightbox2/dist/js/lightbox";
import {initScroll} from "@/front/scroll"

import "owl.carousel/dist/assets/owl.carousel.css"
import "owl.carousel"

import "flatpickr/dist/flatpickr.min.css"
import flatpickr from "flatpickr"
import { Czech } from "flatpickr/dist/l10n/cs"

import "nette.ajax.js"

import Nette from "@/front/netteForms"
Nette.initOnLoad()
window.Nette = Nette

document.addEventListener("DOMContentLoaded", () => {
	$.nette.init()

	initScroll()

	lightbox.option({
		wrapAround: true,
		showImageNumberLabel: false
	});

	new LazyLoad({
		elements_selector: ".img-lazy"
	})

	const owl = $(".fleet-carousel").owlCarousel({
		loop: false,
		margin: 30,
		nav: true,
		navText: [
			"<i class='mdi mdi-chevron-left mdi-scale-1-5'></i>",
			"<i class='mdi mdi-chevron-right mdi-scale-1-5'></i>"
		],
		dots: true,
		autoplay: false,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1024: {
				items: 3
			},
			1440: {
				items: 4
			}
		}
	})

	$('.btn-fleet-carousel').click(function() {
		owl.trigger('next.owl.carousel')
	})

	$("[data-toggle='menu']").on("click", () => {
		$("body").toggleClass("menu-opened")
		$("[data-toggle='menu']").toggleClass("collapsed")
		$(".main-menu").toggleClass("collapsed")
	})

	$(".hide-menu").on("click", () => {
		$("body").removeClass("menu-opened")
		$("[data-toggle='menu']").addClass("collapsed")
		$(".main-menu").addClass("collapsed")
	})

	// window.addEventListener('orientationchange', adjustSliderHeight)
	// adjustSliderHeight()

	initSelectPicker()
	initDatepicker()
})

function adjustSliderHeight() {
	if (window.innerWidth <= 992) {
		$(".slide").not('.slide-subpage').css("height", window.innerHeight)
	}
}


function initSelectPicker() {
	const selects = $('.form-select,[data-bs-select]')

	selects.each(function () {
		const select = $(this)
		const options = {
			theme: 'bootstrap-5',
			placeholder: select.data('none-selected-text') ?? select.data('placeholder'),
			width: select.data('width') ? select.data('width') : select.hasClass('w-100') ? '100%' : 'style',
			minimumResultsForSearch: 4,
			dropdownAutoWidth: true,
			closeOnSelect: !select.prop('multiple'),
		}

		if (select.hasClass('form-select-sm')) {
			options['selectionCssClass'] = 'select2--small'
			options['dropdownCssClass'] = 'select2--small'
		}

		select.select2(options)
	})

	selects.on('select2:open', () => {
		setTimeout(() => {
			$('.select2-search--dropdown .select2-search__field')[0].focus()
		}, 50)
	})

	$(document).on('focus', '.select2-selection.select2-selection--single', function () {
		$(this).closest(".select2-container").siblings('select:enabled').select2('open')
	})

	$('select.select2').on('select2:closing', function (e) {
		$(e.target).data("select2").$selection.one('focus focusin', function (e) {
			e.stopPropagation()
		})
	})
}

function initDatepicker() {
	const config = {
		minDate: "today",
		enableTime: true,
		dateFormat: "j.n.Y H:i",
		time_24hr: true,
	}

	if (window.app.lang === 'cs') {
		config.locale = Czech
	}

	flatpickr(".form-date", config)
}
